module.exports = __webpack_public_path__ + "static/img/yingrenIcon.99b5e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yingrenIcon.png
// module id = scLq
// module chunks = 0